// extracted by mini-css-extract-plugin
export default {"Gsecond":"Gsecond_Gsecond__dSNRI","wrap":"Gsecond_wrap__jTYRF","img":"Gsecond_img__H3RUd","img_tw":"Gsecond_img_tw__cDjWs","img_en":"Gsecond_img_en__1HHyA"};